export function Problem() {
  return (
    <section data-testid="problem-section" className="bg-wafa-cream/40">
      <div className="mx-auto max-w-4xl px-4 py-20 lg:px-6 lg:py-28">
        <h2 className="font-heading text-3xl font-semibold leading-tight tracking-tight text-wafa-deep sm:text-4xl lg:text-5xl">
          Your business grew. Your systems did not.
        </h2>
        <p
          data-testid="problem-body"
          className="mt-6 text-base leading-relaxed text-wafa-ink/85 lg:text-lg"
        >
          The spreadsheets that ran your first few years are starting to break.
          Numbers get re-typed between systems that do not talk to each other,
          reports take days to build, and the vendor who built your last
          platform has stopped answering. None of this is a technology problem
          yet — but left alone, it becomes one.
        </p>
      </div>
    </section>
  );
}
